import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { ConnectState } from "../components/ConnectState";
import { PreviewBanner } from "../components/PreviewBanner";
import { Reveal } from "../components/Reveal";
import { api } from "../lib/api";

export default function Collections() {
  const [state, setState] = useState({ loading: true, connected: true, collections: [] });

  useEffect(() => {
    api
      .get("/collections")
      .then((r) =>
        setState({ loading: false, connected: r.data.connected, collections: r.data.collections || [] })
      )
      .catch(() => setState({ loading: false, connected: true, collections: [] }));
  }, []);

  return (
    <div>
      <PageHeader
        eyebrow="Collections — Curated cuts"
        title="Collections"
        description="Organized in Shopify, streamed here. Every collection your store publishes appears automatically."
      />
      <div className="px-5 py-12 sm:px-10 lg:px-16">
        {state.loading ? (
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="aspect-[4/3] animate-pulse bg-secondary" />
            ))}
          </div>
        ) : !state.connected && state.collections.length === 0 ? (
          <Reveal>
            <ConnectState />
          </Reveal>
        ) : state.collections.length === 0 ? (
          <p className="border border-border p-16 text-center font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
            No collections published yet — create them in Shopify
          </p>
        ) : (
          <>
            {!state.connected && <PreviewBanner />}
            <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {state.collections.map((c, i) => (
              <Reveal key={c.id} delay={i * 0.08}>
                <Link
                  to={`/collections/${c.handle}`}
                  data-testid={`collection-card-${c.handle}`}
                  className="group relative block aspect-[4/3] overflow-hidden border border-border bg-card transition-colors hover:border-signal/60"
                >
                  {c.image?.url && (
                    <img
                      src={c.image.url}
                      alt={c.title}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 flex items-end justify-between p-5">
                    <h3 className="font-display text-xl font-bold uppercase tracking-tight text-white sm:text-2xl">
                      {c.title}
                    </h3>
                    <ArrowUpRight className="h-5 w-5 text-white transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
                  </div>
                </Link>
              </Reveal>
            ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
